import { useTriggerProcessingPipelineMutation } from '@warebee/frontend/data-access-api-graphql';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { formatInteger } from '../../common/formatHelper';
import LoadingIndicator from '../../components/LoadingIndicator';
import { Button } from '../../components/actions/Button';
import * as Icon from '../../components/icons';
import { Container } from '../../components/layout/ContainerFlex';
import { ScreenTitle } from '../../components/layout/ScreenTitle';
import { Stat } from '../../components/stats/Stat';
import { StatGroup } from '../../components/stats/StatGroup';
import { processingPipelineSelected } from '../store/processingPipelines.state';
import ProcessingPipelineSettingsPanel from './ProcessingPipelineSettingsPanel';

const ProcessingPipelineViewPanel: React.FC = () => {
  const { t } = useTranslation('dataset');
  const pipeline = useRecoilValue(processingPipelineSelected);
  const [callTrigger] = useTriggerProcessingPipelineMutation();
  if (_.isNil(pipeline)) {
    return <LoadingIndicator selfCenter message={t`Loading...`} />;
  }

  return (
    <Container
      key={`processing-pipeline-view-panel-${pipeline.id}`}
      data-component="ProcessingPipelineViewPanel"
      col
      hasOverflowY
    >
      <ScreenTitle
        title={pipeline.title}
        subtitle={t`Pipeline`}
        isSticky
        // helpNavTo={'importer/importer'}
        icon={Icon.ImportTransform}
      />
      <Button
        label={t`Run`}
        onPress={() =>
          callTrigger({
            variables: {
              input: {
                pipelineId: pipeline.id,
              },
            },
          })
        }
      />
      <StatGroup horizontal className="!m-0" classNameStatGroupItems="!p-0.5">
        <Stat
          hasHelper
          isPreview
          title={t`Pipeline's jobs count`}
          value={formatInteger(pipeline.jobs?.totalCount)}
          isFullWidth
          inPanelMode
        />
      </StatGroup>
      <ProcessingPipelineSettingsPanel />
    </Container>
  );
};
export default ProcessingPipelineViewPanel;
